import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export default class LessonsController extends Controller {
  queryParams = ['searchQuery', 'precinct', 'perPage', 'pageNumber']

  @tracked searchQuery = ''

  @tracked precinct = ''

  @tracked perPage = 20

  @tracked pageNumber = 1
}

declare module '@ember/controller' {
  interface Registry {
    'subscription-type/lessons': LessonsController
  }
}
